export default __webpack_public_path__ + "static/media/slide-label.b71091aa.svg";